var _circle, _path, _path2, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaregiving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 23.231,
    cy: 21.707,
    r: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M11.684 21.322l8.82-8.82 8.82 8.82-8.82 8.82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M35.07 15.578l-.961.961-19.712 19.712a3.023 3.023 0 01-4.276 0l-4.544-4.544a3.023 3.023 0 010-4.276L26.612 6.396a3.023 3.023 0 014.276 0l3.272 3.272.734.734"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 20.472,
    cy: 18.962,
    r: 0.001
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 17.724,
    cy: 21.698,
    r: 0.001
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 20.524,
    cy: 24.498,
    r: 0.001
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiving);
export default __webpack_public_path__ + "static/media/caregiving.69cc05cb56d72610b0e6f8f66b588206.svg";
export { ForwardRef as ReactComponent };